import { useEffect, useState, useContext } from "react";
import { Controller, useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import * as _ from "lodash";
import moment from "moment/moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { MDBCol, MDBRow } from "mdbreact";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import DeleteIcon from "@mui/icons-material/Delete";
import { Box, IconButton, Tooltip } from "@mui/material";
import { Download } from "@mui/icons-material";
import "../../ReportDetails/Verification/Verification.scss";
import { Button, COLORS, GenericDropdown, Input, Label, Modal, Switch } from "abs-ui-components";
import AbsModal from "../../../common/absModal/AbsModal";
import Loader from "../../../common/Loader/Loader";
import CustomTable from "../../../common/customTable/CustomTable";
import { accessAPIForResponse } from "../../../services/api-services/api-implementations";
import axiosHttp from "../../../services/interceptor";
import { emitToasterMsg } from "../../../services/toasterUtility";
import { reportsActions } from "../../../store/reports/reports.slice";
import AutocompleteDropdown from "../../../common/autocompleteDropdown/AutocompleteDropdown";
import { ClaimsContext } from "../../../services/ClaimsService";
import { ClaimType } from "../../../constants/claims";
import { DATE_FORMAT_DD_MMM_YYYY } from "../../../constants/dateFormats";
import VerificationSelectFiles from "../../ReportDetails/Verification/VerificationSelectFiles";
import "./FEUComplianceBalanceReportsPage.scss";

const Verification = (props) => {
	const { reportDetails, handleRefresh } = props;
	const { userHasClaim } = useContext(ClaimsContext);
	const [selectedVerifier, setSelectedVerifier] = useState();
	const [selectedVerifyDate, setSelectedVerifyDate] = useState(null);
	const [selectedVerifyMoment, setSelectedVerifyMoment] = useState(null);
	const [isSelectFilesModalOpen, setIsSelectFilesModalOpen] = useState(false);
	const [selectedFiles, setSelectedFiles] = useState([]);
	const [associatedDocumentsData, setAssociatedDocumentsData] = useState([]);
	const [loader, setLoader] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [confirmDelete, setConfirmDelete] = useState(false);
	const [selectedDocument, setSelectedDocument] = useState(null);
	const [verificationEnabled, setVerificationEnabled] = useState(false); // Fixed typo: SetverificationEnabled to setVerificationEnabled
	const [showUpdateVerifierModal, setShowUpdateVerifierModal] = useState(false);
	const user = useSelector((state) => state.userInfo.userData);
	const [options, setOptions] = useState([{ value: "Review Letter", label: "Review Letter" }]);
	const [templateType, setTemplateType] = useState("");

	const {
		control,
		handleSubmit,
		formState: { errors },
		reset,
	} = useForm();

	const onSelectFilesEvent = () => {
		setIsSelectFilesModalOpen(!isSelectFilesModalOpen);
		if (isSelectFilesModalOpen) {
			setSelectedFiles([]);
		}
	};

	const dispatch = useDispatch();

	const onTemplateOptionChange = (selectedOption) => {
		setTemplateType(selectedOption[0]);
	};

	const onVerifierChange = (selected) => {
		setSelectedVerifier(selected?.value);
	};

	const VerificationColumns = [
		{
			header: "Published Documents",
			accessorKey: "documentFileName",
		},
		{
			header: "Revision Number",
			accessorKey: "revisionNumber",
		},

		{
			header: "To be made available to Client?",
			accessorKey: "isAvailableToClient",
			hidden: !userHasClaim(ClaimType.AVAILABLE_FOR_CLIENT_CHECK),
			enableSorting: false,
			enableColumnActions: false,
			enableColumnFilters: false,
			muiTableHeadCellProps: {
				align: "center",
			},
			muiTableBodyCellProps: {
				align: "center",
			},
			muiTableFooterCellProps: {
				align: "center",
			},
			Cell: ({ row: { original } }) => {
				const [selected, setSelected] = useState(original.isAvailableToClient === true ? "Yes" : "No");
				const handleChange = (link) => {
					setSelected(link);
					handleAvailableForClient(link, original.documentId);
				};
				return <Switch links={["Yes", "No"]} selected={selected} onChange={(link) => handleChange(link)} />;
			},
		},

		{
			header: "Action",
			accessorKey: "action",
			enableSorting: false,
			enableColumnActions: false,
			enableColumnFilters: false,
			muiTableHeadCellProps: {
				align: "center",
			},
			muiTableBodyCellProps: {
				align: "center",
			},
			muiTableFooterCellProps: {
				align: "center",
			},
			Cell: ({ row: { original } }) => (
				<>
					<Box sx={{ display: "flex", gap: "1rem" }}>
						<Tooltip title="Download">
							<IconButton
								color="info"
								onClick={(e) => {
									e.stopPropagation();
									handleDownload(original.documentId, original.documentFileName);
								}}
							>
								<Download sx={{ color: "#0645AD" }} />
							</IconButton>
						</Tooltip>
					</Box>
					<Box sx={{ display: "flex", gap: "1rem" }}>
						<Tooltip title="Delete">
							<IconButton
								color="error"
								onClick={(e) => {
									e.stopPropagation();
									handleDeleteBtnClick(original, true);
								}}
							>
								<DeleteIcon />
							</IconButton>
						</Tooltip>
					</Box>
				</>
			),
		},
	];

	useEffect(() => {
		if (reportDetails?.reportId) {
			GetVerifyEngineersList();
			GetAssociatedDocuments();
		}
	}, [reportDetails?.reportId]);

	const GetAssociatedDocuments = async () => {
		await axiosHttp.get(`api/FeuComplianceBalance/docs?reportId=${reportDetails?.reportId}`).then((response) => {
			if (response && response?.data?.isSuccess) {
				const responseData = response?.data?.data;
				transformData(responseData);
			}
		});
	};

	const transformData = (data) => {
		let assignedDocsData = [];
		data.forEach((element) => {
			element.IsAvailableForClient = element.IsAvailableForClient === false ? "No" : "Yes";
			assignedDocsData.push(element);
		});
		setAssociatedDocumentsData(data);
	};

	const GetVerifyEngineersList = async (input) => {
		try {
			const response = await accessAPIForResponse("GetVerifyEngineers", null, [input]);
			if (response && response.isSuccess) {
				const verifier_options = response.data.map((obj, index) => ({
					label: obj.emailAddress,
					value: obj.emailAddress,
					id: index + 1,
				}));

				if (reportDetails && reportDetails?.latestVerifier?.trim()) {
					setSelectedVerifier(reportDetails?.latestVerifier);
				}

				return verifier_options.filter((option) => option.value !== reportDetails?.latestReviewer); // Exclude the current user's email
			}
			return [];
		} catch (error) {
			console.error("Error fetching verify engineers:", error);
			return [];
		}
	};

	useEffect(() => {
		if (reportDetails?.dateOfIssuance) {
			const parsed = moment(reportDetails?.dateOfIssuance, [DATE_FORMAT_DD_MMM_YYYY, "YYYY-MM-DD", "YYYY-MM-DDTHH:mm:ss"]);
			if (parsed.isValid()) {
				setSelectedVerifyMoment(parsed);
				setSelectedVerifyDate(parsed.format(DATE_FORMAT_DD_MMM_YYYY));
			}
		}
	}, [reportDetails?.dateOfIssuance]);

	const handleChangeDate = (value) => {
		if (!value || !value.isValid || !value.isValid()) {
			setSelectedVerifyMoment(null);
			setSelectedVerifyDate(null);
			return;
		}
		setVerificationEnabled(true);
		setSelectedVerifyMoment(value);
		const formatted = value.format(DATE_FORMAT_DD_MMM_YYYY);
		setSelectedVerifyDate(formatted);
	};

	const onVerificationComplete = () => {
		if (reportDetails?.reportId && selectedVerifyDate) {
			axiosHttp
				.put(
					`api/FeuComplianceBalance/complete-verification?reportId=${reportDetails?.reportId}&verificationDate=${encodeURIComponent(selectedVerifyDate)}`
				)
				.then((response) => {
					if (response?.data?.isSuccess) {
						handleRefresh();
						emitToasterMsg("success", "Verification Completed Successfully");
						dispatch(reportsActions.setVerificationStatus(true));
					}
				});
		} else {
			emitToasterMsg("error", "Please select verification complete date");
		}
	};

	const onSubmitToVerifier = () => {
		if (reportDetails?.reportId && selectedVerifier && selectedVerifier !== "0") {
			axiosHttp.put(`api/FeuComplianceBalance/assign-verifier?reportId=${reportDetails?.reportId}&userEmail=${selectedVerifier}`).then((response) => {
				if (response?.data && response?.data?.isSuccess) {
					handleRefresh();
					emitToasterMsg("success", "Submitted to Verifier Successfully");
					dispatch(reportsActions.setVerificationStatus(true));
				}
			});
		} else {
			emitToasterMsg("error", "Please select verifier");
		}
	};

	const changeVerifierForReport = () => {
		if (reportDetails?.reportId && selectedVerifier && selectedVerifier !== "0") {
			axiosHttp.put(`api/FeuComplianceBalance/assign-verifier?reportId=${reportDetails?.reportId}&userEmail=${selectedVerifier}`).then((response) => {
				if (response && response?.data?.isSuccess) {
					handleRefresh();
					emitToasterMsg("success", "Verifier Updated Successfully");
					setShowUpdateVerifierModal(false);
				}
			});
		} else {
			emitToasterMsg("error", "Please select verifier");
		}
	};

	const onRejectReport = (formData) => {
		const requestPayload = {
			reportId: reportDetails?.reportId,
			remarks: formData?.reason,
		};
		axiosHttp.put(`/api/FeuComplianceBalance/reject-verification`, requestPayload).then((response) => {
			if (response && response?.data?.isSuccess) {
				toggleClose();
				handleRefresh();
				emitToasterMsg("success", "Report rejected");
				dispatch(reportsActions.setVerificationStatus(true));
			}
		});
	};

	const uploadDocuments = (files) => {
		const formData = new FormData();
		files.forEach((file) => {
			formData.append("DocumentFiles", file);
		});
		formData.append("ReportId", reportDetails?.reportId);

		setLoader(true);

		axiosHttp
			.post(`api/FeuComplianceBalance/upload-docs`, formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
			})
			.then((response) => {
				if (response?.data?.isSuccess === false) {
					const errorMessage = response?.data?.errorMessage || "An error occurred while uploading documents.";
					emitToasterMsg("error", errorMessage);
				} else {
					emitToasterMsg("success", "Files uploaded successfully");
					GetAssociatedDocuments();
					toggleClose();
				}
				setLoader(false);
			})
			.catch((error) => {
				setLoader(false);
				console.error(error);
			});
	};

	const handleUploadClick = () => {
		uploadDocuments(selectedFiles);
		setSelectedFiles([]);
	};

	const handleDownloadForEdit = () => {
		setLoader(true);
		axiosHttp
			.get(`api/FeuComplianceBalance/download-review-letter?&reportId=${reportDetails?.reportId}`, {
				responseType: "blob",
			})
			.then((response) => {
				if (response?.data?.type !== "application/json") {
					const url = window.URL.createObjectURL(new Blob([response?.data]));
					const link = document.createElement("a");
					link.href = url;
					link.setAttribute("download", "Review Letter.docx");

					document.body.appendChild(link);
					link.click();
					setLoader(false);
					emitToasterMsg("success", "Template downloaded successfully.");
				} else {
					setLoader(false);
					emitToasterMsg("error", "Report status is not valid to generate the template");
				}
			})
			.catch((error) => {
				setLoader(false);
				console.error(error);
			});
	};

	const uploadForPublishing = () => {
		setLoader(true);
		axiosHttp
			.get(`api/FeuComplianceBalance/publish-template-doc?reportId=${reportDetails?.reportId}`)
			.then((response) => {
				const reponseData = response?.data;
				if (reponseData && reponseData?.isSuccess) {
					GetAssociatedDocuments();
					emitToasterMsg("success", "Report published successfully.");
				} else if (reponseData && !reponseData?.isSuccess) {
					emitToasterMsg("error", reponseData?.errorMessage);
				}
				setLoader(false);
			})
			.catch((error) => {
				setLoader(false);
				console.error(error);
			});
	};

	const handleAvailableForClient = async (link, documentId) => {
		const requestPayload = {
			"documentId": documentId,
			"reportId": reportDetails?.reportId,
			"isAvailable": link === "Yes" ? true : false
		};
		await axiosHttp.put("api/FeuComplianceBalance/avail-to-client", requestPayload).then((response) => {
			if (response && response.data?.isSuccess) {
			}
		});
	};

	const handleDownload = (documentId, documentName) => {
		setLoader(true);
		axiosHttp
			.get(`api/FeuComplianceBalance/download-doc?reportId=${reportDetails?.reportId}&documentId=${documentId}`, {
				responseType: "blob",
			})
			.then((response) => {
				const url = window.URL.createObjectURL(new Blob([response.data]));
				const link = document.createElement("a");
				link.href = url;
				link.setAttribute("download", documentName);
				document.body.appendChild(link);
				link.click();
				setLoader(false);
				emitToasterMsg("success", "Document downloaded successfully.");
			})
			.catch((error) => {
				setLoader(false);
				console.error(error);
			});
	};

	const handleModal = () => {
		if (reportDetails?.reportId) {
			setShowModal(true);
		}
	};

	const handleUpdateVerifierModal = () => {
		if (reportDetails?.reportId && selectedVerifier && selectedVerifier !== "0") {
			setShowUpdateVerifierModal(true);
		} else {
			emitToasterMsg("error", "Please select verifier");
		}
	};

	const toggleClose = () => {
		setShowModal(false);
	};

	const toggleCloseForRejectModal = () => {
		setShowModal(false);
		reset();
	}

	const handleDeleteBtnClick = (row) => {
		setConfirmDelete(true);
		setSelectedDocument(row);
	};

	const handleDeletingRecord = () => {
		axiosHttp({
			url: `api/FeuComplianceBalance/delete-doc?reportId=${reportDetails?.reportId}&documentId=${selectedDocument.documentId}`,
			method: "delete",
		})
			.then((res) => {
				setConfirmDelete(false);
				if (res && res?.data?.isSuccess) {
					GetAssociatedDocuments();
					emitToasterMsg("success", "Deleted Successfully");
				} else if (!res?.data?.isSuccess) {
					emitToasterMsg("error", res?.data?.errorCode);
				}
			})
			.catch((error) => {
				setConfirmDelete(false);
				console.error(error.response.data.errorMessage);
			});
	};

	useEffect(() => {
		setTemplateType(options[0]?.value);
	}, [options]);

	return (
		<>
			{loader && <Loader />}
			<MDBRow className="mt-4">
				<MDBCol md={"6"}>
					<div className="feucbvr-verification-container">
						<div
							className={`my-div  ${reportDetails?.status === "Verification Completed" || reportDetails?.latestReviewer === "" ? "disabled" : ""}`}
						>
							{reportDetails?.isShowRejectionInfoEnabled && reportDetails?.status !== "Verification Completed" && (
								<div>
									<MDBRow className="d-flex justify-content-between mb-4">
										<MDBCol md="3">
											<Label className="label-text" name="Rejected by :" />
										</MDBCol>
										<MDBCol md="9">{reportDetails?.rejectorName}</MDBCol>
									</MDBRow>
									<MDBRow className="d-flex justify-content-between mb-4">
										<MDBCol md="3">
											<Label className="label-text" name="Remarks :" />
										</MDBCol>
										<MDBCol md="9">{reportDetails?.rejectionReason}</MDBCol>
									</MDBRow>
								</div>
							)}
							<MDBRow className="d-flex mb-4">
								<MDBCol md="3">
									<Label name="Verifier :" bold />
								</MDBCol>
								<MDBCol md="5" className="verifier-dropdown">
									<div>
										<AutocompleteDropdown
											className="inputHeight"
											id="search-vessel-id"
											isClearable
											loadOptions={async (inputText) => {
												const options = await GetVerifyEngineersList(inputText);
												return options;
											}}
											placeholder={selectedVerifier || "Please Select Verifier"}
											onChange={onVerifierChange}
											autoFocus={false}
											customStyles={{
												menuList: (provided) => ({
													...provided,
												}),
											}}
										/>
									</div>
								</MDBCol>
								<MDBCol md="3">
									{reportDetails?.isUpdateVerifierEnabled && selectedVerifier !== user.email && <Button onClick={() => handleUpdateVerifierModal()}>Update</Button>}

									{reportDetails?.isAssignVerifierEnabled && (
										<Button disabled={!selectedVerifier} onClick={() => onSubmitToVerifier()}>
											Submit to Verifier
										</Button>
									)}
								</MDBCol>
							</MDBRow>

							<MDBRow className="date-picker-dropdown mt-4">
								<MDBCol md="3" className="d-flex">
									<Label name="Verification Complete Date :" bold />
								</MDBCol>
								<MDBCol>
									<LocalizationProvider
										dateAdapter={AdapterMoment}
										className="verification-datePicker"
										localeText={{ fieldMonthPlaceholder: (params) => (params.contentType === "digit" ? "MM" : params.format) }}
									>
										<DatePicker
											value={selectedVerifyMoment}
											onChange={handleChangeDate}
											format={
												DATE_FORMAT_DD_MMM_YYYY
											}
											sx={{
												".MuiInputBase-root": {
													height: "35px",
													width: "98%",
												},
											}}
										/>
									</LocalizationProvider>
								</MDBCol>
							</MDBRow>

							<MDBRow className="mt-4 status-btn">
								<MDBCol className="col-8 d-flex justify-content-end">
									<Button
										disabled={reportDetails?.isVerificationCompleteEnabled && verificationEnabled ? false : true}
										onClick={onVerificationComplete}
										primaryBackgroundColor="#DC1E34"
										primaryColor="#DC1E34"
									>
										Verification Complete
									</Button>

									{reportDetails?.isRejectVerificationEnabled && (
										<Button
											className="reject-btn ml-4"
											primaryBackgroundColor={COLORS.RED.DARK}
											primaryColor={COLORS.RED.DARK}
											disabled={!verificationEnabled}
											onClick={handleModal}
										>
											Reject
										</Button>
									)}
								</MDBCol>
							</MDBRow>
						</div>
					</div>
				</MDBCol>

				<MDBCol md={"6"} className="verification-template-container mt-4">
					<div className="verification-template">
						<MDBRow className="d-flex justify-content-between mb-4">
							<MDBCol md="2">
								<Label name="Template Generator :" className="mt-2" bold />
							</MDBCol>
							<MDBCol md="3" className="review-dropdown">
								<GenericDropdown options={options} selected={templateType} handleChange={onTemplateOptionChange} />
							</MDBCol>
							<div className="d-flex ml-3 download-btn-container">
								<div>
									<Button disabled={false} onClick={handleDownloadForEdit}>
										Download for edit
									</Button>
								</div>
								<div className="ml-3">
									<Button disabled={false} onClick={uploadForPublishing} variant="secondary">
										Upload for publishing
									</Button>
								</div>
							</div>
							<MDBCol md=""></MDBCol>
							<MDBCol></MDBCol>
						</MDBRow>
						<MDBRow className="d-flex justify-content-between document-type">
							<MDBCol md="2">
								<Label name="New Document Type :" className="mt-2" bold />
							</MDBCol>
							<MDBCol>
								<Button disabled={false} variant="secondary" className="ml-1" onClick={onSelectFilesEvent}>
									Select Files
								</Button>
							</MDBCol>
						</MDBRow>
					</div>
				</MDBCol>
			</MDBRow>
			<div>
				<div className="mt-4">
					<CustomTable
						columnsData={VerificationColumns.filter((column) => !column.hidden)}
						renderTableData={associatedDocumentsData}
						customProps={{
							enableSort: false,
							enableToptoolbar: false,
							handleExportTable: false,
							showExportButton: false,
							showSwitch: true,
						}}
					/>

					{isSelectFilesModalOpen && (
						<AbsModal isOpen={isSelectFilesModalOpen} title="Select Files" onClose={setIsSelectFilesModalOpen} close={onSelectFilesEvent}>
							<VerificationSelectFiles
								handleUploadClick={handleUploadClick}
								toggleModal={onSelectFilesEvent}
								toggleClose={onSelectFilesEvent}
								selectedFiles={selectedFiles}
								setSelectedFiles={setSelectedFiles}
							></VerificationSelectFiles>
						</AbsModal>
					)}

					{showModal && (
						<AbsModal isOpen={showModal} title="Reject" onClose={setShowModal} close={toggleCloseForRejectModal}>
							<div className="pb-5">
								<form onSubmit={handleSubmit(onRejectReport)}>
									<div className="confirmation-modal-container p-3">
										<Label name="Please enter the reason for rejection" required bold />
										<Controller
											name="reason"
											control={control}
											rules={{
												required: "Reason is required",
											}}
											render={({ field }) => (
												<>
													<Input
														id="reason"
														type="text"
														onChange={field.onChange}
														value={field.value}
														autoFocus={false}
														className="name-input mt-2"
														placeholder="Enter your reason"
													/>
													{errors["reason"] && <p className="error">{errors["reason"].message}</p>}
												</>
											)}
										/>
										<div className="d-flex justify-content-end mt-5 mr-3">
											<button type="submit" className="mr-3 save-button" id="save-update-btn-portcode">
												Reject
											</button>
											<button
												id="cancel-btn-portcode"
												type="button"
												className="clear-button"
												onClick={() => {
													toggleClose();
													reset();
												}}
											>
												Cancel
											</button>
										</div>
									</div>
								</form>{" "}
							</div>
						</AbsModal>
					)}

					{showUpdateVerifierModal && (
						<div className="confirmation-modal-container">
							<Modal
								isOpen={showUpdateVerifierModal}
								modalHeader
								padding={"70px"}
								headerHeight={"50px"}
								showFooter
								onCloseClickListener={() => {
									setShowUpdateVerifierModal(false);
								}}
								footer={
									<div className="d-flex justify-content-end fixed-action-btns p-4">
										<Button
											className="modal-delete-btn"
											onClick={() => changeVerifierForReport()}
											primaryColor={COLORS.RED.DARK}
											primaryBackgroundColor={COLORS.RED.LIGHT}
										>
											Confirm
										</Button>
										<Button
											className="modal-cancel-btn"
											onClick={() => {
												setShowUpdateVerifierModal(false);
											}}
										>
											Cancel
										</Button>
									</div>
								}
							>
								<div>Access will be removed from the current verifier and granted to the selected verifier.</div>
							</Modal>
						</div>
					)}

					<div className="confirmation-modal-container">
						<Modal
							isOpen={confirmDelete}
							modalHeader
							padding={"70px"}
							headerHeight={"50px"}
							showFooter
							onCloseClickListener={() => {
								setConfirmDelete(false);
							}}
							footer={
								<div className="d-flex justify-content-end fixed-action-btns p-4">
									<Button
										className="modal-delete-btn"
										onClick={handleDeletingRecord}
										primaryColor={COLORS.RED.DARK}
										primaryBackgroundColor={COLORS.RED.LIGHT}
									>
										Delete
									</Button>
									<Button
										className="modal-cancel-btn"
										onClick={() => {
											setConfirmDelete(false);
										}}
									>
										Cancel
									</Button>
								</div>
							}
						>
							<div>Are you sure you want to delete this document?</div>
						</Modal>
					</div>
				</div>
			</div>
		</>
	);
};

export default Verification;